<template>
  <div class="upload-file">
    <div v-if="process >= 0 && process < 100" class="process">
      <img src="@/assets/img/loading.png" alt="" />
      <span>正在上传中...{{ process }}%</span>
      <span class="cancel" @click="cancel">取消</span>
    </div>
    <template v-if="process === 100">
      <div v-if="preview && coverType === 'pdf'" class="preview">
        <img src="@/assets/icons/icon_pdf.png" alt="">
        <div class="preview-name">{{ checkFileName }}</div>
        <div class="preview-btn">
          <div @click="previewFile">预览</div>
          <div @click="deleteFile">删除</div>
        </div>
      </div>
      <img class="coverImg" v-else-if="coverType === 'word'" :src="getTextCover" alt="" />
      <img class="coverImg" v-else-if="coverType === 'image'" :src="fileList[0].url" alt="" />
      <video class="coverImg" v-else-if="coverType === 'video'" :src="fileList[0].url" alt=""></video>
      <div class="otherImg" v-else><a-icon type="check-circle" style="padding-right: 5px;" /> 已上传</div>
    </template>
    <a-button :class="{ hasCover: process === 100 }" v-if="process !== 100">
      <img src="@/assets/icons/icon_upload.png" alt="" srcset="" />
      <div class="text">选择文件</div>
      <div class="desc" v-for="item of desc" :key="item">{{ item }}</div>
    </a-button>
    <input
      v-show="!(process === 100 && preview)"
      class="file"
      ref="uploadInput"
      type="file"
      :accept="acceptInput"
      :multiple="multiple"
      @change="handleChange"
    />
    <img class="delete" v-if="process === 100 && !preview" src="@/assets/icons/icon_s.png" alt="" srcset="" @click="deleteFile" />
    <canvas ref="canvas" style="display:none;"></canvas>
    <a-tooltip :overlayClassName="'up-tooltip'" placement="bottomLeft" v-if="coverType === 'software'">
      <template slot="title">
        <div>
          <p>注意事项</p>
          <p>1、上传文件格式需为压缩包形式(建议用 好压软件 进行压缩) ；</p>
          <p>
            2、上传的ZIP包上传时的名称必须和运行软件名称一致, 如:运行软件 demo.exe, 打包ZIP时也需要命名为demo.zip
            (该规则上传的软件,可以添加到老师的备课中, 且可以在课堂进行播控使用)；
          </p>
          <p>3、如不按命名规则进行上传，则仅限在平台中进行存放；</p>
        </div>
      </template>
      <div :class="['tips', model !== 'admin' ? 'right-tips' : '']"></div>
    </a-tooltip>
    <a-modal
      title="文件预览"
      :visible="previewVisible"
      @cancel="previewVisible = false"
      :footer="null"
      width="80%"
      style="top: 20px"
    >
      <iframe
        :src="`${fileList[0] && fileList[0].url}`"
        frameborder="0"
        style="width: 100%; height: 80vh;"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
import OSS from 'ali-oss'
import SparkMD5 from 'spark-md5'
import { formatFileSize } from '@/utils/other'
import { OSSConfig, md5Check, utilReport } from '@/api/common'

export default {
  name: 'Test',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    desc: {
      type: Array,
      default: () => []
    },
    accept: {
      type: Array,
      default: () => []
    },
    coverType: {
      type: String,
      default: 'image'
    },
    generateCover: {
      type: Boolean,
      default: true
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileMaxSize: {
      type: Number,
      default: 2 * 1024 // MB为单位
    },
    preview: { // 目前仅支持word文件预览
      type: Boolean,
      default: false
    },
    isCommon: { // 是否是通用上传。非通用上传：学生报告批改上传
      type: Boolean,
      default: true
    },
    pathname: {
      type: String,
      default: ''
    },
    useCDN: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flag: false,
      process: -1,
      fileList: [],
      model: '',
      checkFileName: '',
      previewVisible: false
    }
  },
  computed: {
    acceptInput() {
      const acceptPoint = []
      this.accept.forEach(item => {
        acceptPoint.push('.' + item)
      })
      return acceptPoint.join(',')
    },
    getTextCover() {
      let result = ''
      console.log('fileUrl', this.fileUrl)
      const fileName = this.checkFileName || this.fileUrl
      if (this.coverType === 'word') {
        const regex = /\.([a-zA-Z0-9]+)$/
        const match = fileName.match(regex)
        const bgMap = {
          ppt: 'ppt',
          pdf: 'pdf',
          doc: 'word',
          docx: 'word',
          xls: 'xlsx',
          xlsx: 'xlsx',
          pptx: 'ppt'
        }
        if (match) {
          result = require(`@/assets/img/bg_${bgMap[match[1]]}_cover.png`)
        } else {
          result = require('@/assets/img/word.png')
        }
      }
      return result
    }
  },
  watch: {
    fileUrl: {
      handler(val) {
        if (val) {
          console.log('val ----->', val)
          this.process = 100
          this.flag = false
          this.fileList = [
            {
              url: val
            }
          ]
        }
      },
      deep: true
    }
  },
  methods: {
    handleChange(el) {
      this.fileList = []
      el.target.files.forEach(file => {
        const fileType = file.name.toLowerCase()
        this.checkFileName = file.name.toLowerCase()
        console.log('fileType ----->', fileType)
        if (this.accept.length > 0 && !this.accept.some(item => fileType.includes(item))) {
          this.$message.error('文件格式不正确，支持的格式为：' + this.accept)
          return
        }
        switch (this.coverType) {
          case 'word':
            if (file.size > 1024 * 1024 * 1024 * 1) {
              this.setTips('1G')
              return
            }
            break
          case 'image':
            if (file.size > 1024 * 1024 * 200) {
              this.setTips('200M')
              return
            }
            break
          case 'audio':
            if (file.size > 1024 * 1024 * 1024 * 1) {
              this.setTips('1G')
              return
            }
            break
          case 'video':
            if (file.size > 1024 * 1024 * 1024 * 2) {
              this.setTips('2G')
              return
            }
            break
          case 'model':
            if (file.size > 1024 * 1024 * 1024 * 2) {
              return
            }
            break
          case 'software':
            if (file.size > 1024 * 1024 * 1024 * 2) {
              return
            }
            break
        }
        this.checkMD5File(file)
      })
    },
    setTips(size) {
      this.$message.error('文件大小不能超过' + size)
    },
    async checkMD5File(file, isCover) {
      const uploadData = {
        name: file.name,
        originalSize: file.size,
        size: formatFileSize(file.size),
        type: file.type,
        url: ''
      }
      this.getVideoFrame(file, uploadData)
      this.process = 0
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)
      fileReader.onload = async e => {
        const spark = new SparkMD5.ArrayBuffer()
        spark.append(e.target.result)
        const fileMD5 = spark.end()
        const response = await md5Check({ file_md5: fileMD5 })
        const resfile = response.data
        if (resfile.md5_check || !this.isCommon) {
          this.uploadFile(file, uploadData, fileMD5, isCover)
        } else if (resfile.file_info) {
          uploadData.url = resfile.file_info.file_url
          this.flag = true
          this.process = 100
          console.log('this.coverType ----->', this.coverType)
          console.log('uploadData ----->', uploadData)
          if (isCover) {
            this.$emit('cover', uploadData)
          } else {
            if (this.coverType === 'video' && !uploadData.type.includes(this.coverType)) return
            this.fileList.push(uploadData)
            this.$message.success('上传成功')
            console.log('this.fileList ----->', this.fileList)
            this.$emit('uploadData', this.fileList)
          }
        }
        console.log(fileMD5)
      }
    },
    uploadFile(file, uploadData, fileMD5, isCover) {
      const fileType = file.name.split('.')[file.name.split('.').length - 1]
      const newData = new Date().getTime() / 1000
      let client
      if (localStorage.OSSExpire > newData) {
        const ossConfigData = JSON.parse(localStorage.OSSConfigData)
        this.client = client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: ossConfigData.AccessKeyId,
          accessKeySecret: ossConfigData.AccessKeySecret,
          stsToken: ossConfigData.SecurityToken,
          bucket: 'growlib-glp-u-resources',
          secure: true
        })
      } else {
        OSSConfig().then(res => {
          this.client = client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: res.data.Credentials.AccessKeyId,
            accessKeySecret: res.data.Credentials.AccessKeySecret,
            stsToken: res.data.Credentials.SecurityToken,
            bucket: 'growlib-glp-u-resources',
            secure: true
          })
          localStorage.OSSConfigData = JSON.stringify(res.data.Credentials)
          localStorage.OSSExpire = res.data.Credentials.Expire
          const currentTime = new Date()
          const pathname = this.pathname || 'school-level-platform/' + currentTime.getFullYear() +
                (currentTime.getMonth() + 1) +
                currentTime.getDate() +
                '/' +
                fileMD5 +
                '.' +
                fileType
          client
            .multipartUpload(
              pathname,
              file,
              {
                // 进度回调函数  获取上传进度值
                progress: (p, checkpoint) => {
                  let complete = (p * 100) | 0
                  if (complete >= 99) {
                    complete = 99
                  }
                  this.process = complete
                  // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
                  // tempCheckpoint = checkpoint;
                },
                partSize: 1000 * 1024, // 指定分片大小
                timeout: 120000 // 设置超时时间
              }
            )
            .then(result => {
              const baseurl = 'https://src-glp-u-resource.growlib.com'
              const spliturl = 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com'
              const ossurl = result.res.requestUrls[0].split('?')[0]
              if (this.isCommon) {
                utilReport({
                  status: 1,
                  file_url: this.useCDN ? baseurl + ossurl.split(spliturl)[1] : ossurl,
                  file_md5: fileMD5
                })
              }
              uploadData.url = this.useCDN ? baseurl + ossurl.split(spliturl)[1] : ossurl
              this.process = 100
              this.flag = true
              if (isCover) {
                this.$emit('cover', uploadData)
              } else {
                if (this.coverType === 'video' && !uploadData.type.includes(this.coverType)) return
                this.fileList.push(uploadData)
                this.$message.success('上传成功')
                this.$emit('uploadData', this.fileList)
              }
            })
        })
      }
    },
    getVideoFrame(file, uploadData) {
      if (file && file.type === 'video/mp4' && this.generateCover) {
        const videoURL = URL.createObjectURL(file)
        const video = document.createElement('video')
        console.log('file ----->', file)
        video.src = videoURL
        video.addEventListener('loadeddata', () => {
          // 设置画布的宽高与视频相同
          const canvas = this.$refs.canvas
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight

          // 播放视频以确保可以截取帧
          video.currentTime = 3 // 截取第一帧
        })

        video.addEventListener('seeked', () => {
          const canvas = this.$refs.canvas
          const context = canvas.getContext('2d')

          // 在画布上绘制当前视频帧
          context.drawImage(video, 0, 0, canvas.width, canvas.height)

          // 将画布内容转为图片并显示
          canvas.toBlob(blob => {
            const file = new File([blob], '封面图.png', { type: 'image/png' })
            this.checkMD5File(file, true)
          })
          // 释放视频 URL
          URL.revokeObjectURL(videoURL)
        })

        video.load()
      }
    },
    cancel() {
      this.process = -1
      this.flag = false
      this.fileList = []
      this.client.cancel()
    },
    deleteFile() {
      this.process = -1
      this.flag = false
      this.fileList = []
      this.$refs.uploadInput.value = ''
      this.$emit('uploadData', this.fileList)
    },
    previewFile() {
      this.previewVisible = true
    }
  },
  mounted() {
    this.model = this.$route.query.model
  }
}
</script>

<style lang="less" scoped>
.upload-file {
  width: 100%;
  height: 100%;
  position: relative;
  .process {
    width: 100%;
    height: 100%;
    background: #fcfcfc;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    img {
      animation: rotate 1s linear infinite;
      width: 26px;
      margin-bottom: 11px;
    }
    span {
      font-weight: 400;
      color: #258d64;
      line-height: 17px;
      letter-spacing: 1px;
    }
    .cancel {
      font-size: 12px;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 6px;
      color: #c1c1c1;
    }
  }
  .preview{
    width: 100%;
    height: 100%;
    background: #fcfcfc;
    border: dashed 1px #e0e0e0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img{
      width: 22px;
      margin-bottom: 12px;
    }
    div{
      font-size: 12px;
      font-weight: bold;
      color: #000000;
      line-height: 20px;
      letter-spacing: 1px;
    }
    .preview-btn{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      div {
        cursor: pointer;
        color: #FF6D00;
      }
    }
  }
  .ant-btn {
    width: 100%;
    height: 100%;
    padding: 24px 0 9px 0;
    border: dashed 1px #e0e0e0;
    background: #fcfcfc;
    img {
      width: 22px;
      height: 22px;
      margin-bottom: 12px;
    }
    .text {
      font-size: 12px;
      font-weight: bold;
      color: #000000;
      line-height: 20px;
      letter-spacing: 1px;
    }
    .desc {
      font-size: 12px;
      color: #7281a4;
      line-height: 17px;
      text-align: left;
      font-style: normal;
      text-align: center;
    }
  }
  .hasCover {
    opacity: 0;
  }
  .file {
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    cursor: pointer;
    position: absolute;
  }
  .coverImg {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background: #7a7979;
  }
  .otherImg {
    width: 100%;
    height: 100%;
    background: #f1fff8;
    border: 1px solid #d0f5c8;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    font-weight: 12px;
    font-weight: bold;
    color: #00b042;
  }
  .delete {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 22px;
    cursor: pointer;
    z-index: 999;
    opacity: 0.8;
  }
  .tips {
    position: absolute;
    top: 0;
    left: -17px;
    width: 14px;
    height: 14px;
    z-index: 9999;
    background-image: url('~@/assets/icons/icon_wh@2x.png');
    background-size: 100% 100%;
    &:hover {
      cursor: pointer;
      background-image: url('~@/assets/icons/icon_w_d@2x.png');
    }
  }
  .right-tips {
    top: -27px;
    left: 78px;
  }
}
</style>
<style lang="less">
.up-tooltip {
  max-width: 420px;
  font-size: 12px;
  p {
    margin-bottom: 0px;
    line-height: 25px;
  }
}
</style>
